

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Seja bem vindo(a) !</h5>
                  <p>Faça login para continuar seu trabalho.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="Usuário"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="username"
                  type="text"
                  placeholder="Digite seu usuário"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">Email is required.</span>
                  <span v-if="!$v.email.email">Please enter valid email.</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="Senha"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="Informe sua senha"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  Password is required.
                </div>
              </b-form-group>
              <b-form-checkbox
                  class="form-check"
                  id="customControlInline"
                  name="checkbox-1"
                  value="accepted"
                  unchecked-value="not_accepted"
                >
                  Remember me
                </b-form-checkbox>
              <div class="mt-3 d-grid">
                <b-button type="button" variant="primary" class="btn-block" @click="login">Entrar</b-button
                >
              </div>
              <div class="mt-4 text-center">
                <h5 class="font-size-14 mb-3">Entre com suas redes sociais</h5>

                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-primary text-white border-primary"
                    >
                      <i class="mdi mdi-facebook"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-info text-white border-info"
                    >
                      <i class="mdi mdi-twitter"></i>
                    </a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="javascript: void(0);"
                      class="social-list-item bg-danger text-white border-danger"
                    >
                      <i class="mdi mdi-google"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock me-1"></i> Esqueceu sua senha?
                </router-link>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            Você não tem uma conta ?
            <router-link
              tag="a"
              to="/register"
              class="fw-medium text-primary"
              >Cria agora</router-link
            >
          </p>
          <p>
            © {{ new Date().getFullYear() }} Infinity. Criado com
            <i class="mdi mdi-heart text-danger"></i> by Guri Web
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>





<script>
import Layout from "../../layouts/auth";
import { ApiAuth } from "./ApiAuth"
export default {

    beforeRouteEnter(routeTo, routeFrom, next) {
        console.log('++++++++dentro da vm++++++++')
        console.log('to: ',routeTo.name)
        console.log('from: ',routeFrom.name)

      /* this.praOndeVai = from.name
      this.praOndeVai = to.name */
      next(vm => {
        //vm.praOndeVai = routeFrom.name
        vm.praOndeVai = routeFrom.path
        if(vm.praOndeVai === null)
          vm.praOndeVai = '/home'
      })
    },

    beforeRouteLeave (to, from, next) {
      console.log('saida to: ', to.name)
      console.log('saida from: ', from.name)
      next()
    },

    components:{ Layout },
    name:"Login",
    data() {
        return {
            praOndeVai:"home",
            isAuthError:"",
            authError:"",
            username:"",
            password:"",
            api: new ApiAuth(),
        }
    },
    mounted() {
        this.$refs.username.focus()
    },
    methods: {
        async login(){
            let username = this.username
            let pass = this.password

            if(username==""){
                this.$swal("Requerido", "Usuário Requerido", "warning")
                return
            }
            if(pass=="" || pass.length <=3){
                this.$swal("Requerido", "Senha Requerida e deve ter no mínimo três caracteres", "warning")
                return
            }

            let token = await this.api.login(username, pass)

            if('access' in token){
                localStorage.setItem("access", token.access)
                localStorage.setItem("refresh", token.refresh)
                localStorage.setItem("user", JSON.stringify({
                    username: "admin",
                    email: "admin@themesbrand.com",
                    token: "fake-jwt-token"
                }))
                localStorage.setItem("username", username)
                //////////////////this.$router.push('/home')
                console.log('pra onde vai: ', this.praOndeVai)
                this.$router.push(this.praOndeVai)
                //vai ser pego o usuário no nav-bar.vue para mostrar no cabeçalho
                this.$root.$emit("login", username)

            } else if('detail' in token){
                this.mensagemErro(token.detail)
            } else if('error' in token){
                this.mensagemErro(token.error)
            } else {
                this.mensagemErro("Erro Inesperado")
            }





        }
    },
    
}
</script>


<style scoped>

</style>
